export const USER_IDPS = {
    ADFS: 'ADFS',
    UMS: 'UMS',
}